<div class="label_properties">
  <small class="debug">{{me}}</small>

  <!-- <div class="cardInner1">
  <div [style.grid-area]="'A'">
    <app-input-autocomplete [selectedItem]="assignedEventParam" [checkKeyUp]="false" [items]="eventParams" (changeItem)="onChangeEventParam($event)"></app-input-autocomplete>
  </div>
  <div [style.grid-area]="'B'">
    <button mat-icon-button matTooltip="{{'general.assignEventParam' | transloco}}">
      <mat-icon>post_add</mat-icon>
    </button>
  </div>
</div> -->

@if (dynamicsInitialized) {
  <div>
    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
    </dynamic-form>
  </div>
}
<br>
  @if (sourceType == 'ifttt' || sourceType == 'stringify') {
    <div>
      <mat-label>{{sourceType}} webhooks</mat-label><br>
      <mat-form-field class="demo-full-width">
        <textarea inputrestriction="basic1" class="dynamic-input" matInput placeholder="URL">
        </textarea>
      </mat-form-field>
      <br>
        <mat-form-field class="demo-full-width">
          <textarea inputrestriction="basic1" class="dynamic-input" matInput placeholder="Body">
          </textarea>
        </mat-form-field>
      </div>
    }
    <hr/>
    <br>
      <br>
        <br>
        </div>
